// CheckedBulletList.tsx
import { Box, Typography } from "@mui/material"
import { Variant } from "@mui/material/styles/createTypography"
import { FC } from "react"

type CheckedBulletListProps = {
    items: string[]
    secondary?: boolean
    variant?: Variant
    fontWeight?: number | undefined
}

/**
 * List with prefix text.
 */
const CheckMarkListWithPrefix: FC<CheckedBulletListProps> = ({
    items,
    secondary,
    variant,
    fontWeight,
}) => (
    <ul style={{ paddingLeft: 15 }}>
        {items.map((item, i) => (
            <Box
                key={item}
                component="li"
                mb={1}
                display="flex"
                alignItems="center"
                color={secondary ? "text.secondary" : "text.primary"}
            >
                <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={{ whiteSpace: "nowrap" }}
                >
                    Step {i + 1}
                </Typography>
                <Box ml={1}>
                    <Typography variant={variant} fontWeight={fontWeight}>
                        {item}
                    </Typography>
                </Box>
            </Box>
        ))}
    </ul>
)

CheckMarkListWithPrefix.defaultProps = {
    secondary: false,
    fontWeight: undefined,
    variant: "body1",
}

export default CheckMarkListWithPrefix
